<template>
	<v-menu
		v-model="menu"
		:close-on-content-click="false"
		:nudge-right="40"
		transition="scale-transition"
		offset-y
		class="background"
		full-width
		min-width="290px">

		<template v-slot:activator="{ on }">
			<v-text-field
				v-model="selected"
				prepend-inner-icon="event"
				readonly
				:hide-details="hide_details"
				:hint="hint"
				:rules="rules"
				v-on="on">
				<template v-slot:label>
					{{ param | maestroParamLabel }}
				</template>
			</v-text-field>
		</template>

		<v-date-picker
			v-model="selected"
			@input="menu = false"
			color="primary color--text"
			class="background"
			locale="fr-fr"
			reactive
			:readonly="readonly"
			:first-day-of-week="1">
		</v-date-picker>

	</v-menu>
</template>

<script>
export default {
	props: [
		'value',
		'rules',
		'param',
		'hint',
		'readonly',
		'hide_details'
	],
	data () {
		return {
			menu: false
		}
	},
	computed: {
		selected: {
			get () {
				return this.value
			},
			set (value) {
				this.$emit('change', value)
			}
		}
	}
}
</script>

<style lang="stylus" scoped>
>>>.v-picker__body
	background: transparent !important
</style>



// WEBPACK FOOTER //
// src/components/field_date.vue